module.exports = __webpack_public_path__ + "img/6.a31e55ae.jpg";